import {
  AfterViewInit,
  ChangeDetectorRef,
  ElementRef,
  EventEmitter,
  HostListener,
  Inject,
  Input,
  ViewChild,
  ViewEncapsulation,
  Component,
  OnInit,
} from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { firstValueFrom, startWith, Subject, takeUntil } from 'rxjs';
import {
  tareoStatusV2,
  TaskValidaton,
  TempTaskModal,
} from '../../interfaces/task.interface';
import * as moment from 'moment';
import { GenericResponse } from 'src/app/shared/interfaces/generic.interface';
import { TaskService } from '../../services/task.service';
import { SmartAlertService } from 'src/app/shared/components/smart-alert/smart-alert.service';
import { SmartAlertResult } from 'src/app/shared/components/smart-alert/interfaces/custom-dialog.interface';
import { moduleActive } from 'src/app/shared/helpers/moduleActive';
import { modeType } from 'src/app/shared/interfaces/inputype.interface';
import { formGroupTaskInit } from './helper/formgroup';
import {
  formatOutOfScheduleRangesMessage,
  getMinutesInSchedule,
  getOutOfScheduleRanges,
  marksOfJornada,
  isInsideOutOfScheduleRanges,
  OutOfScheduleRange,
  subtractOccupiedRanges,
  withoutNextDawnSlices,
  mapErrorsToTaskArrays,
} from '../../helpers/functions';
import { localDB } from 'src/app/shared/helpers/localStorage';
import { IntervalService } from 'src/app/core/layout/components/interval-marks/service/interval-service.service';
import { initCodeProjectHelper } from '../task/helper/helper-task';
import { ConfigurationsService } from 'src/app/shared/services/configurations.service';
import {
  configurations,
  GroupOption,
} from 'src/app/shared/interfaces/configurations.interface';
import { TaskStatus } from './helper/interfaces';
import { IconComponent } from 'src/app/shared/components/icon/icon.component';
import { CommonModule } from '@angular/common';
import { DateComponent } from 'src/app/shared/components/inputs/simple/date/date.component';
import { MinutesTaskComponent } from 'src/app/shared/components/inputs/simple/minutes-task/minutes-task.component';
import { SelectComponent } from 'src/app/shared/components/inputs/simple/select/select.component';
import { SelectGroupComponent } from 'src/app/shared/components/inputs/simple/select-group/select-group.component';
import { TimeComponent } from 'src/app/shared/components/inputs/simple/time/time.component';
import { TextareaComponent } from 'src/app/shared/components/inputs/simple/textarea/textarea.component';
import { PipesModule } from 'src/app/shared/pipes/pipe-module';
import { MatHint } from '@angular/material/form-field';
import { groupBy } from 'src/app/shared/helpers/groupBy';
import { MarkDetail } from 'src/app/shared/components/maps/interface/interface';
import { CollaboratorMarksResponse } from 'src/app/core/layout/components/interval-marks/interfaces/interfaces';
import { REFRESH_INDEXED } from 'src/app/core/indexedDB/helpers/enums.enums';
import { setHoursMins } from 'src/app/shared/helpers/timeAndHours';
import { TaskTempCardComponent } from '../task-temp-card/task-temp-card.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { SpinnerComponent } from 'src/app/shared/components/spinner/spinner.component';
import { ACTIVITY_TASK_TYPE } from 'src/app/modules/indicators/interfaces/enums';
import { TaskRefreshService } from '../../services/task-refresh.service';
import { formatTimeHours } from '../../../../shared/helpers/formatTime';
import { TIME_TYPE } from 'src/app/shared/enums/task.enum';

interface OutOfScheduleData {
  dDate: string;
  aIntervals: MarkDetail[];
  scheduleIntervals: CollaboratorMarksResponse[];
}

@Component({
  selector: 'mg-tasks-modal-crud',
  templateUrl: './task-modal.component.html',
  styleUrls: ['./task-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    IconComponent,
    CommonModule,
    DateComponent,
    MinutesTaskComponent,
    SelectComponent,
    SelectGroupComponent,
    TimeComponent,
    TextareaComponent,
    PipesModule,
    MatHint,
    TaskTempCardComponent,
    MatProgressBarModule,
    SpinnerComponent,
  ],
})
export class TaskModalCrudComponent implements OnInit, AfterViewInit {
  @Input() aConfigurations: any;
  @ViewChild('topList') private readonly topList: ElementRef;
  onAdd = new EventEmitter();

  mode: modeType = 'create';
  calendarMode: modeType = 'create';
  typeHourMode: modeType = 'create';

  last_mode: modeType | null = 'create';
  last_calendarMode: modeType | null = 'create';
  last_typeHourMode: modeType | null = 'create';
  taskForm: FormGroup;
  tempForm: TempTaskModal | null = null;
  initForm: TempTaskModal | null = null;
  bdArray: TempTaskModal[] = [];
  currentValidations: TaskStatus | undefined;
  listValidations: TaskStatus[] = [];
  listValidationsBase: TaskStatus[] = [];
  loading: boolean = false;
  spinnerLoad: boolean = true;
  minDate: Date;
  maxDate: Date;
  maxCurrentMinutesRegular: number = 0;
  maxCurrentMinutesNoRegular: number = 0;
  maxMinRecuperar: number = 0;
  maxCurrentMinutes: number = 0;
  minutesToUseRegular: number = 0;
  minutesToUseNoRegular: number = 0;
  minutesToUse: number = 0;
  today: moment.Moment;
  intervalsObj: MarkDetail[] = [];
  scheduleIntervals: CollaboratorMarksResponse[] = [];
  isSmallScreen: boolean = window.screen.width < 415;
  public isProjectModuleActive: boolean = false;
  oTareoByStatus: { [key: string]: string[] } = {};

  aProjects: GroupOption[] = [];
  aAllProjects: configurations[] = [];
  aAllRequirements: configurations[] = [];
  aAllCaterories: configurations[] = [];
  Requirements: { [key: string]: configurations[] } = {};
  Categories: { [key: string]: configurations[] } = {};
  aRequirementsFiltered: configurations[] = [];
  aCategoriesFiltered: configurations[] = [];
  aTipos_Horas = [];
  loadingCat: boolean = false;
  loadingRq: boolean = false;
  taskMessage: { sName: string; sMessage: string }[] = [];
  nMinsRecuperar: number = 0;
  currentColId: number = 0;
  sNombreColaborador: string = '';
  TIPOS_HORA_ARRAY: configurations[] = [];
  validationsOptions: { [key: string]: TaskValidaton[] } = {};

  isEditRawTask: boolean = false;
  initStatus = {
    rq: false,
    cat: false,
    typeHour: false,
  };
  editError: string = '';
  temp_tipo_hora = '';
  private scheduleRangeRequest = 0;
  private dawnMinutesRequest = 0;

  fakeId: number = 1;
  currentId: number = 0;
  configs: { [key: string]: configurations[] } = {};

  private readonly destroy$ = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<TaskModalCrudComponent>,
    private readonly _taskService: TaskService,
    private readonly _smartAlert: SmartAlertService,
    private readonly _taskRefreshService: TaskRefreshService,
    private readonly _configService: ConfigurationsService,
    private readonly _intervalService: IntervalService,
    private readonly cdr: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  get sHour_Message(): string {
    const hora = this.taskForm.get('dHora_Fin')?.value;
    const fecha = this.taskForm.get('dFecha_Fin')?.value;
    const message =
      hora && fecha
        ? `Fin de la actividad a las ${moment(fecha).format(
          'HH:mm'
        )} del ${moment(fecha).format('DD')} de ${moment(fecha).format(
          'MMMM'
        )}`
        : '';
    return message;
  }

  ngOnInit(): void {
    this.setTodayJourney();
    this.setScheduleIntervals();
    this.setValidationsForm();
    this.initTaskForm();
    // Lee estado de PRY del localStorage (actualizado en app.component.ts)
    this.isProjectModuleActive = moduleActive('PRY');
  }

  ngAfterViewInit(): void {
    this.initProjects();
    this.initTaskStatus();
  }

  setTodayJourney() {
    this.today = moment();
    if (moment().hours() <= 6) {
      this.today = moment().subtract(1, 'days');
    }
  }

  initTaskForm() {
    this.taskForm = formGroupTaskInit(this.today.format('YYYY-MM-DD'));
    this.taskForm.get('dFecha_Registro')?.patchValue(this.today.format());
    this.taskForm.get('sCodigo_Tipo_Actividad')?.patchValue('1');
  }

  setTaskMessages() {
    this.taskMessage = [];
    this.editError = '';
    this.setRecuperacionMessage();
    this.setFueraHorarioMessage();
    this.setSinMarcaError();
    this.setHorasAdicionalesMessage();
    this.setMarcarFueraJornadaError();
    this.setIntoScheduleError();
    this.setFueraJornadaError();
    this.setColaboradorMarksError();
    this.setOutOfScheduleRangeError();
  }

  private setRecuperacionMessage(): void {
    if (this.nMinsRecuperar && this.nMinsRecuperar > 0) {
      let message = `<p><strong>Recuperación:</strong> Tiene <strong>${this.nMinsRecuperar
        } minutos </strong> (${setHoursMins(
          this.nMinsRecuperar
        )}) por recuperar. `;

      if (this.validationsOptions['priority_rec']?.[0]?.active) {
        message +=
          'No podrá registrar otro tipo de <strong>hora adicional</strong> hasta regularizar.';
      }

      this.taskMessage.push({
        sName: 'Recuperación',
        sMessage: message,
      });
    }
  }

  private setFueraHorarioMessage(): void {
    const hasNoRegularHours = !this.TIPOS_HORA_ARRAY.some(
      (x) => Number(x.sCodigo) === TIME_TYPE.HORARIO_REGULAR
    );
    const hasValidations =
      this.currentValidations && this.currentValidations.nReadyMark > 0;

    if (hasNoRegularHours && hasValidations && this.TIPOS_HORA_ARRAY.length) {
      this.taskMessage.push({
        sName: 'Fuera de horario',
        sMessage: `<p><strong>Fuera de horario:</strong> Solo puede horas adicionales.</p>`,
      });
    }
  }

  private setSinMarcaError(): void {
    if (this.currentValidations?.nReadyMark == 0) {
      this.editError = `<p><strong>Sin marca:</strong> Debe tener marcaciones para registrar tareas.</p>`;
    }
  }

  private setHorasAdicionalesMessage(): void {
    const noRegularTimeOption = this.validationsOptions['no_regular_time'];
    const hasNoRegularTime =
      noRegularTimeOption?.[0]?.value;
    const isExtrasNotAllowed = !this.currentValidations?.isExtrasAllowed;

    if (hasNoRegularTime && isExtrasNotAllowed && !this.isEditRawTask) {
      let nDays = noRegularTimeOption[0].value;
      let sDays = nDays == 1 ? '1 día hábil' : `${nDays} días hábiles`;
      this.taskMessage.push({
        sName: 'Horas adicionales',
        sMessage: `<p><strong>Horas adicionales no disponibles:</strong> Solo tiene <strong>${sDays}</strong> luego de la fecha de efecto para su registro.</p>`,
      });
    }
  }

  private setMarcarFueraJornadaError(): void {
    const tipoHorasValue = this.taskForm.get('sCodigo_Tipo_Horas')?.value;
    const noRegularHoursRequired =
      this.currentValidations?.nRequiredNoRegular === 0;
    const noMarks = this.currentValidations?.nReadyMark == 0;

    if (
      !this.isEditRawTask &&
      tipoHorasValue != '1' &&
      noRegularHoursRequired &&
      noMarks
    ) {
      this.editError = `<p>Para registrar horas adicionales <strong>debe marcar fuera de la jornada laboral.</strong></p>`;
    }
  }

  private setIntoScheduleError(): void {
    const hasScheduleError = this.taskForm
      .get('dHora_Inicio')
      ?.hasError('isIntoSchedule');
    const hasFinValue = this.taskForm.get('dHora_Fin')?.value;

    if (hasScheduleError && hasFinValue) {
      let inicio = moment(
        `${this.currentValidations?.dDate} ${this.currentValidations?.entrada}`
      ).format('HH:mm');
      let fin = moment(
        `${this.currentValidations?.dDate} ${this.currentValidations?.salida}`
      ).format('HH:mm');
      this.editError = `<p>No puedes registrar horas adicionales entre las <strong>${inicio} y ${fin}</strong>.</p>`;
    }
  }

  private setOutOfScheduleRangeError(): void {
    const message = this.taskForm
      .get('dHora_Inicio')
      ?.getError('fueraDeRangoMarcacion');

    if (typeof message === 'string' && message) {
      this.editError = message;
    }
  }

  private setFueraJornadaError(): void {
    const isSameDay = this.today.isSame(this.currentValidations?.dDate, 'days');
    const isBeforeEntrance = this.today.isBefore(
      this.currentValidations?.entrada,
      'hours'
    );
    const isRegularSchedule =
      this.currentValidations?.sEstado_Horario == 'HORARIO_REGULAR';
    const isRegularHours =
      this.taskForm.get('sCodigo_Tipo_Horas')?.value == '1';

    if (isSameDay && isBeforeEntrance && isRegularSchedule && isRegularHours) {
      this.editError = `<p><strong>Fuera de jornada:</strong> tu jornada laboral comienza a las ${this.currentValidations?.entrada} horas.</p>`;
    }
  }

  private setColaboradorMarksError(): void {
    let seflCol = localDB.getItem('idColaborador');
    this.currentColId = this.initForm?.nId_Colaborador ?? Number(seflCol);

    const isDifferentColaborator = Number(seflCol) != this.currentColId;
    const hasInsufficientMarks =
      this.currentValidations &&
      this.currentValidations.nReadyMark <
      this.currentValidations.nRecomended_Marks;

    if (isDifferentColaborator && hasInsufficientMarks && this.isEditRawTask) {
      this.editError = `<p>No se puede calcular correctamente los minutos a llenar hasta <strong>regularizar las marcaciones</strong></p>`;
      this.mode = 'read';
      this.typeHourMode = 'read';
      this.calendarMode = 'read';
    }
  }

  setTipoHoras(tipo_hora?: number) {
    this.TIPOS_HORA_ARRAY = [];
    this.taskForm.get('sCodigo_Tipo_Horas')?.setErrors({ noHouyrsType: false });

    let tipo_Hora_base = this.getFilteredTipoHoraBase();
    this.TIPOS_HORA_ARRAY = this.validateDate(tipo_Hora_base);

    this.setCurrentTipoHora();
    this.taskForm.get('sCodigo_Tipo_Horas')?.markAllAsTouched();
    this.setTaskMessages();
  }

  private getFilteredTipoHoraBase(): configurations[] {
    if (!this.currentValidations) {
      return [];
    }

    let tipo_Hora_base = structuredClone(this.data.TIPO_HORA);
    tipo_Hora_base = this.filterByEstadoHorario(tipo_Hora_base);

    if (this.isEditRawTask) {
      tipo_Hora_base = this.filterForEditRawTask(tipo_Hora_base);
    } else if (this.mode !== 'read') {
      tipo_Hora_base = this.filterForCreateTask(tipo_Hora_base);
    }

    return tipo_Hora_base;
  }

  private filterByEstadoHorario(tipo_Hora_base: configurations[]): configurations[] {
    const estadosExcluirRegular = ['FUERA_HORARIO_REGULAR', 'FERIADO', 'SOLICITUD_POR_DIAS'];

    if (estadosExcluirRegular.includes(this.currentValidations!.sEstado_Horario)) {
      return tipo_Hora_base.filter(
        (x: configurations) => Number(x.sCodigo) != TIME_TYPE.HORARIO_REGULAR
      );
    }
    return tipo_Hora_base;
  }

  private filterForEditRawTask(tipo_Hora_base: configurations[]): configurations[] {
    const no_regular_time = this.validationsOptions['no_regular_time'];
    if (no_regular_time?.[0]?.value && !this.currentValidations?.isExtrasAllowed) {
      tipo_Hora_base = tipo_Hora_base.filter(
        (x: configurations) =>
          Number(x.sCodigo) == TIME_TYPE.HORARIO_REGULAR ||
          this.initForm?.sCodigo_Tipo_Horas == x.sCodigo
      );
    }

    const priority_rec = this.validationsOptions['priority_rec'];

    if (!priority_rec?.[0]?.active) {
      return tipo_Hora_base;
    }

    if (this.nMinsRecuperar) {
      return tipo_Hora_base.filter(
        (x: configurations) =>
          ![TIME_TYPE.COMPENSACIÓN, TIME_TYPE.EXTRAS].includes(Number(x.sCodigo)) ||
          this.initForm?.sCodigo_Tipo_Horas == x.sCodigo
      );
    } else {
      return tipo_Hora_base.filter(
        (x: configurations) =>
          ![TIME_TYPE.RECUPERACIÓN].includes(Number(x.sCodigo)) ||
          this.initForm?.sCodigo_Tipo_Horas == x.sCodigo
      );
    }
  }

  private filterForCreateTask(tipo_Hora_base: configurations[]): configurations[] {
    const priority_rec = this.validationsOptions['priority_rec'];
    const no_regular_time = this.validationsOptions['no_regular_time'];
    if (this.nMinsRecuperar <= 0) {
      tipo_Hora_base = tipo_Hora_base.filter(
        (x: configurations) => Number(x.sCodigo) !== TIME_TYPE.RECUPERACIÓN
      );
    }
    if (no_regular_time?.[0]?.value && !this.currentValidations?.isExtrasAllowed) {
      tipo_Hora_base = tipo_Hora_base.filter(
        (x: configurations) => Number(x.sCodigo) == TIME_TYPE.HORARIO_REGULAR
      );
    }
    if (priority_rec?.[0]?.active) {
      if (this.nMinsRecuperar) {
        tipo_Hora_base = tipo_Hora_base.filter(
          (x: configurations) => ![TIME_TYPE.COMPENSACIÓN, TIME_TYPE.EXTRAS].includes(Number(x.sCodigo))
        );
      } else {
        tipo_Hora_base = tipo_Hora_base.filter(
          (x: configurations) => ![TIME_TYPE.RECUPERACIÓN].includes(Number(x.sCodigo))
        );
      }
    }

    return tipo_Hora_base;
  }

  private setCurrentTipoHora(): void {
    if (this.TIPOS_HORA_ARRAY.length === 0) {
      return;
    }

    this.initStatus.typeHour = true;

    const currentTipo_Hora = this.temp_tipo_hora || this.TIPOS_HORA_ARRAY[0].sCodigo;
    this.prioritizeSelectedTipoHora(currentTipo_Hora);

    this.taskForm.get('sCodigo_Tipo_Horas')?.patchValue(currentTipo_Hora);
  }

  private prioritizeSelectedTipoHora(currentTipo_Hora: string): void {
    const index = this.TIPOS_HORA_ARRAY.findIndex(obj => obj.sCodigo === currentTipo_Hora);

    if (index > -1) {
      const [objeto] = this.TIPOS_HORA_ARRAY.splice(index, 1);
      this.TIPOS_HORA_ARRAY.unshift(objeto);
    }
  }

  validateDate(aTipos_Horas: configurations[]): configurations[] {
    if (this.isEditRawTask || this.mode === 'read') {
      return aTipos_Horas;
    }

    return this.applyPriorityFullTaskValidations(aTipos_Horas);
  }

  private applyPriorityFullTaskValidations(tipo_Hora_base: configurations[]): configurations[] {
    const priority_full_task = this.validationsOptions['priority_full_task'];

    if (!this.shouldApplyPriorityFullTask(priority_full_task, tipo_Hora_base)) {
      return tipo_Hora_base;
    }

    const allDates = this.getAllPriorityDates();

    if (allDates.length === 0) {
      return tipo_Hora_base;
    }

    this.markNonRegularHoursAsInvalid(tipo_Hora_base, allDates);
    return tipo_Hora_base;
  }

  private shouldApplyPriorityFullTask(
    priority_full_task: TaskValidaton[] | undefined,
    tipo_Hora_base: configurations[]
  ): boolean {
    if (!priority_full_task?.[0]?.active) {
      return false;
    }

    const hasIncompleteOrFaltaDays =
      this.oTareoByStatus['INCOMPLETO'].length > 0 ||
      this.oTareoByStatus['FALTA'].length > 0;

    const completosCMarcadFaltantes = this.getCompletosConMarcadFaltantes();
    const hasCompletosConMarcadFaltantes = completosCMarcadFaltantes.length > 0;

    const hasNonRegularHours = tipo_Hora_base.some((x) => x.sCodigo != '1');

    return (hasIncompleteOrFaltaDays || hasCompletosConMarcadFaltantes) && hasNonRegularHours;
  }

  private getCompletosConMarcadFaltantes(): string[] {
    return this.listValidations
      .filter(x => this.isCompletoConMarcadFaltante(x))
      .map(x => x.dDate);
  }

  private isCompletoConMarcadFaltante(x: TaskStatus): boolean {
    const estadoValido = x.sEstado == 'COMPLETO';
    const tieneMarcas = x.nReadyMark > 0;
    const marcasImpares = x.nReadyMark % 2 !== 0;
    const horarioValido = ['HORARIO_REGULAR', 'SOLICITUD_POR_HORAS'].includes(x.sEstado_Horario);

    return estadoValido && tieneMarcas && marcasImpares && horarioValido;
  }

  private getAllPriorityDates(): string[] {
    const completosCMarcadFaltantes = this.getCompletosConMarcadFaltantes();

    let allDates = [
      ...this.oTareoByStatus['INCOMPLETO'],
      ...this.oTareoByStatus['FALTA'],
      ...completosCMarcadFaltantes
    ];

    return this.filterAndSortDates(allDates);
  }

  private filterAndSortDates(dates: string[]): string[] {
    const filteredDates = dates.filter(x => moment(x).isBefore(this.today, 'days'));

    if (filteredDates.length === 0) {
      return [];
    }

    filteredDates.sort((a, b) => moment(b).diff(moment(a)));
    return filteredDates;
  }

  private markNonRegularHoursAsInvalid(tipo_Hora_base: configurations[], allDates: string[]): void {
    const message = this.getPriorityMessage(allDates);

    for (const [index, value] of tipo_Hora_base.entries()) {
      if (value.sCodigo != '1') {
        tipo_Hora_base[index].bIsInvalidOption = true;
        tipo_Hora_base[index].sMessage = message;
      }
    }
  }

  private getPriorityMessage(allDates: string[]): string {
    const firstDate = moment(allDates.at(-1)).format('DD-MM-YYYY');
    const lastDate = moment(allDates[0]).format('DD-MM-YYYY');

    return allDates.length > 1
      ? `Debe completar primero las horas regulares. Desde: ${firstDate} hasta ${lastDate}`
      : `Debe completar primero las horas regulares del día ${firstDate}`;
  }

  setCalentarStatus() {
    this.calendarMode = 'create';

    if (
      this.isEditRawTask &&
      this.initForm!.sCodigo_Tipo_Horas != '1' &&
      this.currentValidations &&
      !this.currentValidations?.isExtrasAllowed
    ) {
      this.calendarMode = 'read';
    }

    if (
      !this.isEditRawTask &&
      this.initForm &&
      this.data.oTask?.sCodigo_Tipo_Horas != '1' &&
      !this.currentValidations?.isExtrasAllowed
    ) {
      this.calendarMode = 'create';
      this.taskForm.get('dFecha_Registro')?.patchValue(this.today);
    }
  }

  initProjects() {
    if (this.isProjectModuleActive) {
      this.aAllProjects = [];
      let allPry = this.data.PROYECTOS.filter(
        (x: configurations) =>
          !(this.data.PROYECTOS_COLABORADOR ?? []).some(
            (y: configurations) => y.sCodigo === x.sCodigo
          )
      );
      this.aProjects = initCodeProjectHelper(
        this.taskForm,
        this.data.TIPO_ACTIVIDAD || [],
        this.data.PROYECTOS_COLABORADOR || [],
        allPry || []
      );
      for (const x of this.aProjects) {
        this.aAllProjects = this.aAllProjects.concat(x.groupOptions);
      }
    }
  }

  initMode() {
    this.initializeModeAndForm();

    if (this.data.oTask) {
      this.handleEditMode();
    } else {
      this.handleCreateMode();
    }
  }

  private initializeModeAndForm(): void {
    this.mode = this.data.mode ? this.data.mode : 'create';
    this.initForm = structuredClone(this.data.oTask);
  }

  private handleEditMode(): void {
    const taskToEdit = this.data.oTask;

    this.resetInitStatus();
    this.setCurrentId(taskToEdit);
    this.setColaboradorInfo();
    this.handleExtrasNotAllowed(taskToEdit);
    this.initializeFormForEdit(taskToEdit);
    this.setupEditModeTimeout();
  }

  private handleCreateMode(): void {
    const initialDate = this.getInitialDateForCreate();

    this.taskForm.get('dFecha_Registro')?.patchValue(initialDate);
    this.setCurrentValidations(initialDate);
    this.setValuesChangesFormValues();

    setTimeout(async () => {
      this.taskForm.get('dHora_Inicio')?.patchValue(await this.getDefaultHoraInicio());
    }, 200);

    this.spinnerLoad = false;
  }

  private resetInitStatus(): void {
    this.initStatus = {
      rq: false,
      cat: false,
      typeHour: false,
    };
  }

  private setCurrentId(taskToEdit: any): void {
    if (this.mode === 'create' && this.data.oTask) {
      this.isEditRawTask = false;
      this.currentId = 0;
    } else if (this.mode === 'update') {
      this.isEditRawTask = true;
      this.currentId = taskToEdit.nId;
    } else {
      this.currentId = taskToEdit.nId;
    }
  }

  private setColaboradorInfo(): void {
    this.currentColId = this.data.oTask.nId_Colaborador;
    const seflCol = localDB.getItem('idColaborador');

    if (Number(seflCol) !== this.currentColId) {
      this.sNombreColaborador = this.initForm?.sNombre_Colaborador ?? '';
      this.typeHourMode = 'read';
    }
  }

  private handleExtrasNotAllowed(taskToEdit: any): void {
    const isExtrasNotAllowed = this.mode !== 'create' &&
      !taskToEdit.isExtrasAllowed &&
      this.initForm?.sCodigo_Tipo_Horas !== '1';

    if (isExtrasNotAllowed) {
      this.setMinDateForExtras();
      this.handleRecuperacionIncrement();
    } else if (this.mode === 'create') {
      this.spinnerLoad = false;
    }
  }

  private setMinDateForExtras(): void {
    const oldest = this.listValidations.filter(item => item.isExtrasAllowed);
    const date = moment.min(oldest.map(e => moment(e.dDate))).toDate();
    this.minDate = date;
  }

  private handleRecuperacionIncrement(): void {
    if (!this.isEditRawTask || !this.initForm) {
      return;
    }

    if (Number(this.initForm.sCodigo_Tipo_Horas) === TIME_TYPE.RECUPERACIÓN) {
      for (const x of this.listValidations) {
        x.nTotal_Minutos_Recuperar += this.initForm.nMinutos;
      }
    }
  }

  private initializeFormForEdit(taskToEdit: any): void {
    const initialDate = this.getInitialDateForEdit(taskToEdit);

    this.setCurrentValidations(initialDate);
    this.setValuesChangesFormValues();
    this.initTaskByLocalData(taskToEdit);
  }

  private getInitialDateForEdit(taskToEdit: any): string {
    if (this.mode === 'create') {
      return this.getInitialDateForCreate();
    }
    return taskToEdit.dFecha_Registro;
  }

  private getInitialDateForCreate(): string {
    if (this.data.dateSelected && moment(this.data.dateSelected).isSameOrBefore(this.today)) {
      return moment(this.data.dateSelected).format('YYYY-MM-DD');
    }
    return this.today.format('YYYY-MM-DD');
  }

  private setupEditModeTimeout(): void {
    setTimeout(() => {
      this.handleEditModeTimeout();
      this.setHoraInicioValue();
      this.handleCalendarMode();
    }, 200);
  }

  private handleEditModeTimeout(): void {
    if (this.isEditRawTask) {
      this.setLocalMins(this.initForm);
      this.temp_tipo_hora = this.initForm?.sCodigo_Tipo_Horas ?? '1';
      this.setTipoHoras();
    } else if (this.mode === 'read') {
      this.temp_tipo_hora = this.initForm?.sCodigo_Tipo_Horas ?? '1';
      this.typeHourMode = 'read';
      this.calendarMode = 'read';
      this.taskForm.get('nMinutos')?.disable({ emitEvent: false });
      this.taskForm.get('sDetalle')?.disable({ emitEvent: false });
      this.setTipoHoras();
    }
    if (this.isEditRawTask || this.mode === 'read') {
      this.spinnerLoad = false;
      this.cdr.detectChanges();
    }
  }

  private async setHoraInicioValue(): Promise<void> {
    if (this.initForm) {
      this.taskForm.get('dFecha_Inicio')?.patchValue(this.initForm.dFecha_Inicio);
    } else {
      this.taskForm.get('dHora_Inicio')?.patchValue(await this.getDefaultHoraInicio());
    }
  }

  private handleCalendarMode(): void {
    const isNonRegularHours = this.initForm?.sCodigo_Tipo_Horas !== '1';
    const isExtrasNotAllowed = this.mode !== 'create' &&
      !this.data.oTask.isExtrasAllowed;

    if (this.isEditRawTask && isNonRegularHours) {
      this.calendarMode = 'read';
    } else if (isExtrasNotAllowed && isNonRegularHours) {
      this.data.oTask.dFecha_Registro = this.today.format('YYYY-MM-DD');
    }
  }

  setRequirementsOptions(pry: number) {
    if (pry) {
      this.taskForm.get('sCodigo_Requerimiento')?.patchValue(null);
      this.taskForm.get('sNombre_Requerimiento')?.patchValue(null);
    }

    this.loadingRq = true;
    this.loadingCat = true;

    if (pry) {
      let sProject = this.aAllProjects.find(
        (x) => Number(x.sCodigo) === pry
      )?.sDescripcion;
      this.taskForm.get('sNombre_Proyecto')?.patchValue(sProject);

      if (this.Requirements[`PRY${pry}`]?.length) {
        setTimeout(() => {
          this.aRequirementsFiltered = this.Requirements[`PRY${pry}`];
          let currentRq = this.getCurrentRequirement();
          if (currentRq) {
            this.taskForm.get('sCodigo_Requerimiento')?.patchValue(currentRq);
          }
          this.initStatus.rq = true;
          this.loadingRq = false;
          if (currentRq) {
            this.setCategoriesOptions(Number(currentRq));
          }
        }, 500);
      } else {
        let nUser = localDB.getItem('idUsuario');
        this._configService
          .getConfig(
            REFRESH_INDEXED.EVERY_DAY,
            ['requerimientos_by_pry_active'],
            nUser,
            pry
          )
          .pipe(takeUntil(this.destroy$))
          .subscribe((res) => {
            this.aRequirementsFiltered = res['REQUERIMIENTOS_X_PROYECTO'] || [];
            this.Requirements[`PRY${pry}`] = this.aRequirementsFiltered;
            this.aAllRequirements = [];
            for (const x of Object.values(this.Requirements)) {
              this.aAllRequirements = this.aAllRequirements.concat(x);
            }
            let currentRq = this.getCurrentRequirement();
            if (currentRq) {
              this.taskForm.get('sCodigo_Requerimiento')?.patchValue(currentRq);
            }
            this.initStatus.rq = true;
            this.loadingRq = false;
          });
      }
    } else {
      this.loadingRq = false;
      this.loadingCat = false;
    }
  }

  private getCurrentRequirement(): string | null {
    if (this.mode === 'update') {
      return (
        this.taskForm.get('sCodigo_Requerimiento')?.value ||
        this.aRequirementsFiltered[0]?.sCodigo ||
        null
      );
    } else {
      return !!this.initForm && !this.initStatus.rq
        ? this.initForm.sCodigo_Requerimiento
        : this.aRequirementsFiltered[0]?.sCodigo || null;
    }
  }

  setCategoriesOptions(rq: number) {
    if (rq) {
      this.taskForm.get('sCodigo_Categoria')?.patchValue(null);
      this.taskForm.get('sNombre_Categoria')?.patchValue(null);
    }

    this.loadingCat = true;

    if (rq) {
      let sRq = this.aAllRequirements.find(
        (x) => Number(x.sCodigo) === rq
      )?.sDescripcion;
      this.taskForm.get('sNombre_Requerimiento')?.patchValue(sRq);

      if (this.Categories[`RQ${rq}`]?.length) {
        setTimeout(() => {
          this.aCategoriesFiltered = this.Categories[`RQ${rq}`];
          let currentCat = this.getCurrentCategory();
          if (currentCat) {
            this.taskForm.get('sCodigo_Categoria')?.patchValue(currentCat);
          }
          this.loadingCat = false;
          this.initStatus.cat = true;
        }, 300);
      } else {
        let nUser = localDB.getItem('idUsuario');
        this._configService
          .getConfig(REFRESH_INDEXED.EVERY_DAY, ['categorias'], nUser, 0, rq)
          .pipe(takeUntil(this.destroy$))
          .subscribe((res) => {
            this.aCategoriesFiltered = res['CATEGORIAS'] || [];
            this.Categories[`RQ${rq}`] = this.aCategoriesFiltered;
            this.aAllCaterories = [];
            for (const x of Object.values(this.Categories)) {
              this.aAllCaterories = this.aAllCaterories.concat(x);
            }
            let currentCat = this.getCurrentCategory();
            if (currentCat) {
              this.taskForm.get('sCodigo_Categoria')?.patchValue(currentCat);
            }
            this.loadingCat = false;
            this.initStatus.cat = true;
          });
      }
    } else {
      this.loadingCat = false;
    }
  }

  private getCurrentCategory(): string | null {
    if (this.mode === 'update') {
      return (
        this.taskForm.get('sCodigo_Categoria')?.value ||
        this.aCategoriesFiltered.find(
          (c) => c.sCodigo === this.initForm?.sCodigo_Categoria
        )?.sCodigo ||
        this.aCategoriesFiltered[0]?.sCodigo ||
        null
      );
    } else {
      return !!this.initForm && !this.initStatus.cat
        ? this.initForm.sCodigo_Categoria
        : this.aCategoriesFiltered[0]?.sCodigo || null;
    }
  }

  onProjectChange(value: any) {
    if (value) {
      this.initStatus.rq = true;
      this.initStatus.cat = true;
    } else {
      this.taskForm.get('sCodigo_Requerimiento')?.patchValue(null);
      this.taskForm.get('sCodigo_Categoria')?.patchValue(null);
      this.taskForm.get('sNombre_Requerimiento')?.patchValue(null);
      this.taskForm.get('sNombre_Categoria')?.patchValue(null);
      this.taskForm.get('sNombre_Proyecto')?.patchValue(null);
      this.initStatus.rq = false;
      this.initStatus.cat = false;
      this.cdr.detectChanges();
    }
  }

  initTaskStatus() {
    this.listValidations = [];
    this.listValidationsBase = [];
    let colID = this.data.oTask ? this.data.oTask.nId_Colaborador : null;
    this._taskService
      .getTareoStatusV2(colID)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data: tareoStatusV2) => {
          this.oTareoByStatus = data.oTareoByStatus;
          this.listValidations = data.aAllTareoStatus || [];
          this.listValidationsBase =
            structuredClone(data.aAllTareoStatus) || [];
          this.setMaxMinDate();
          this.initMode();
        },
        error: (err) => { },
      });
  }

  setValidationsForm() {
    this._configService
      .getConfig(REFRESH_INDEXED.EVERY_REFRESH, ['tareo_configs'])
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.validationsOptions = groupBy(
          JSON.parse(res['TAREO_CONFIGS'][0].sDescripcion),
          (i: TaskValidaton) => i.name
        );
      });
  }

  setValuesChangesFormValues() {
    this.taskForm
      .get('dFecha_Registro')
      ?.valueChanges.pipe(takeUntil(this.destroy$), startWith(''))
      .subscribe((value) => {
        if (value) {
          this.temp_tipo_hora = this.taskForm.get('sCodigo_Tipo_Horas')?.value;
          this.setCurrentValidations(moment(value).format('YYYY-MM-DD'));
          if (this.mode == 'create') {
            setTimeout(async () => {
              this.taskForm
                .get('dHora_Inicio')
                ?.patchValue(await this.getDefaultHoraInicio());
            }, 200);
          }
        }
      });

    this.taskForm
      .get('sCodigo_Tipo_Horas')
      ?.valueChanges.pipe(takeUntil(this.destroy$), startWith(''))
      .subscribe((value) => {
        if (value) {
          this.temp_tipo_hora = value;
          this.resetNoRegularDates(value);
          this.setMaxMinutesByTipoHoras();
          let sTipo_Hora = this.data.TIPO_HORA.find(
            (x: configurations) => x.sCodigo === value
          ).sDescripcion;
          this.taskForm.get('sNombre_Tipo_Horas')?.patchValue(sTipo_Hora);
          this.setTaskMessages();
        }
      });

    this.taskForm
      .get('dHora_Inicio')
      ?.valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe(async (value) => {
        const request = ++this.scheduleRangeRequest;
        this.setHoraFin(value);
        await this.validateOutOfScheduleRange(request);
        if (request !== this.scheduleRangeRequest) return;
        this.setTaskMessages();
      });

    this.taskForm
      .get('nMinutos')
      ?.valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe(async (value) => {
        const request = ++this.scheduleRangeRequest;
        this.taskForm.get('nCantidad')?.patchValue(value / 60);
        this.setHoraFin(this.taskForm.get('dHora_Inicio')?.value);
        await this.validateOutOfScheduleRange(request);
        if (request !== this.scheduleRangeRequest) return;
        this.setTaskMessages();
      });

    if (this.isProjectModuleActive) {
      let lastPry = '';
      this.taskForm
        .get('sCodigo_Proyecto')
        ?.valueChanges.pipe(takeUntil(this.destroy$), startWith(''))
        .subscribe((value) => {
          if (value && lastPry != value) {
            this.setRequirementsOptions(Number(value));
            lastPry = value;
          }
        });
      let lastRQ = '';
      this.taskForm
        .get('sCodigo_Requerimiento')
        ?.valueChanges.pipe(takeUntil(this.destroy$), startWith(''))
        .subscribe((value) => {
          if (value && value != lastRQ) {
            this.setCategoriesOptions(Number(value));
            lastRQ = value;
          }
        });
      let lastCat = '';
      this.taskForm
        .get('sCodigo_Categoria')
        ?.valueChanges.pipe(takeUntil(this.destroy$), startWith(''))
        .subscribe((value) => {
          if (value && value != lastCat) {
            let sCat = this.aAllCaterories.find(
              (x) => x.sCodigo === value
            )?.sDescripcion;
            this.taskForm.get('sNombre_Categoria')?.patchValue(sCat);
            this.setTipoActividad(Number(value));
            lastCat = value;
          }
        });
    }
  }

  setTipoActividad(cat: number) {
    let activity = 1;
    if ([12, 5].includes(cat)) {
      activity = ACTIVITY_TASK_TYPE.CALIDAD;
    } else {
      const pry = this.taskForm.get('sCodigo_Proyecto')?.value;
      const selfFiltered = this.aProjects
        .find((p) => p.groupName !== 'Todos')
        ?.groupOptions.find((x) => x.sCodigo === pry);
      activity = selfFiltered
        ? ACTIVITY_TASK_TYPE.REGULARES
        : ACTIVITY_TASK_TYPE.APOYO;
    }

    let sTipo_Actividad = this.data.TIPO_ACTIVIDAD.find(
      (x: configurations) => x.sCodigo === String(activity)
    ).sDescripcion;

    this.taskForm.get('sCodigo_Tipo_Actividad')?.patchValue(String(activity));
    this.taskForm.get('sNombre_Tipo_Actividad')?.patchValue(sTipo_Actividad);
  }

  setHoraFin(horaInicio: string) {
    horaInicio = this.toHHmm(formatTimeHours('Hh:m0', horaInicio));
    if (!!horaInicio && horaInicio.includes(':')) {
      const nMinutos = this.taskForm.get('nMinutos')!.value;
      const fechaRegistro = this.currentValidations?.dDate;
      const fechaHoraInicio = moment(
        `${moment(fechaRegistro).format('YYYY-MM-DD')}T${horaInicio}`,
        'YYYY-MM-DDTHH:mm',
        true
      );
      if (!fechaHoraInicio.isValid()) return;

      const fechaHoraFin = moment(fechaHoraInicio).add(nMinutos, 'minutes');
      const dHoraInicio = fechaHoraInicio.format('HH:mm');
      const dHoraFin = fechaHoraFin.format('HH:mm');
      let fechaFin = fechaHoraFin.format('YYYY-MM-DD');

      if (fechaHoraFin.isBefore(fechaHoraInicio)) {
        fechaFin = moment(fechaHoraFin).add(1, 'day').format('YYYY-MM-DD');
      }
      this.taskForm.patchValue(
        {
          dHora_Inicio: dHoraInicio,
          dHora_Fin: dHoraFin,
          dFecha_Inicio: fechaHoraInicio,
          dFecha_Fin: `${fechaFin} ${dHoraFin}`,
        },
        { emitEvent: false }
      );
      this.taskForm.get('nMinutos')?.markAsTouched();
      this.taskForm
        .get('dHora_Inicio')
        ?.updateValueAndValidity({ onlySelf: true, emitEvent: false });
    }
  }

  resetNoRegularDates(value: string) {
    if(value === '1'){
    this.taskForm.get('dHora_Inicio')?.patchValue(null);
    this.taskForm.get('dHora_Inicio')?.clearValidators();
    this.taskForm.get('dHora_Inicio')?.updateValueAndValidity();
    this.taskForm.get('dHora_fin')?.patchValue(null);
    this.taskForm.get('dFecha_Inicio')?.patchValue(null);
    this.taskForm.get('dFecha_Fin')?.patchValue(null);      
    }else{
      this.taskForm.get('dHora_Inicio')?.setValidators(Validators.required);
    }
  }

  setCurrentValidations(date: string) {
    this.currentValidations = structuredClone(
      this.listValidations.find((v) => v.dDate === date)
    );
    if (this.currentValidations) {
      this.initCurrentMaxMinMinutes();
      this.setMisRecuperar();
      this.setTaskMessages();
      this.setValidationsTaskStatus();
      this.taskForm.setErrors(null);

      if (this.currentValidations.nReadyMark == 0) {
        this.taskForm.setErrors({ noMarks: true });
      }

      if (this.mode == 'create') {
        setTimeout(() => {
          this.setTipoHoras();
        }, 200);
      }
    }
  }

  setMisRecuperar() {
    if (this.currentValidations) {
      let localMins = 0;
      const base = Math.max(
        this.currentValidations?.nTotal_Minutos_Recuperar ?? 0,
        0
      );
      let total = 0;
      for (const x of this.bdArray) {
        if (
          [TIME_TYPE.RECUPERACIÓN].includes(Number(x.sCodigo_Tipo_Horas)) &&
          !x.editState
        ) {
          localMins += x.nMinutos;
        }
      }
      total = Math.max(base - localMins, 0);
      this.nMinsRecuperar = Math.max(total, 0);
      this.maxMinRecuperar =
        Math.min(this.nMinsRecuperar, this.maxCurrentMinutesNoRegular);
      this.setTaskMessages();
    }
  }

  setScheduleIntervals() {
    this.intervalsObj =
      JSON.parse(localDB.getItem('Intervals') || 'null')?.aIntervals || [];
    this.scheduleIntervals = JSON.parse(localDB.getItem('V-HORARIO') || '[]');
  }

  private outOfScheduleDataCache: OutOfScheduleData | null = null;

  private async getIntervalsAndScheduleForDate(dDate: string): Promise<OutOfScheduleData> {
    const isToday = moment(dDate).isSame(this.today, 'day');
    if (!isToday && this.outOfScheduleDataCache?.dDate === dDate) {
      return this.outOfScheduleDataCache;
    }
    const data = isToday
      ? this.getIntervalsAndScheduleFromLocalData(dDate)
      : await this.fetchIntervalsAndScheduleForDate(dDate);
    this.outOfScheduleDataCache = { dDate, ...data };
    return this.outOfScheduleDataCache;
  }

  private getIntervalsAndScheduleFromLocalData(dDate: string): {
    aIntervals: MarkDetail[];
    scheduleIntervals: CollaboratorMarksResponse[];
  } {
    this.setScheduleIntervals();
    return {
      aIntervals: marksOfJornada(this.intervalsObj, dDate),
      scheduleIntervals: this.scheduleIntervals,
    };
  }

  private async fetchIntervalsAndScheduleForDate(dDate: string): Promise<{
    aIntervals: MarkDetail[];
    scheduleIntervals: CollaboratorMarksResponse[];
  }> {
    try {
      const nId_Colab = this.data.oTask
        ? this.data.oTask.nId_Colaborador
        : Number.parseInt(localDB.getItem('idColaborador'));
      const dFecha_Jornada = moment(dDate).format('YYYY-MM-DD');
      const [marksResp, scheduleResp] = await Promise.all([
        firstValueFrom(this._intervalService.getMarksUser(nId_Colab, dFecha_Jornada)),
        firstValueFrom(this._intervalService.getScheduleForExtemp(dFecha_Jornada)),
      ]);
      return {
        aIntervals: (marksResp?.data as any)?.aIntervals || [],
        scheduleIntervals: (scheduleResp?.data as unknown as CollaboratorMarksResponse[]) || [],
      };
    } catch {
      return { aIntervals: [], scheduleIntervals: [] };
    }
  }

  async getDefaultHoraInicio(): Promise<string> {
    const fallback = this.currentValidations?.salida ?? '00:00:00';
    const dDate = this.currentValidations?.dDate;
    if (!dDate) return this.toHHmm(fallback);
    const { available } = await this.getAvailableOutOfScheduleRanges(dDate);
    if (!available.length) return this.toHHmm(fallback);
    return available[0].start.format('HH:mm');
  }

  private async ensureNonRegularRangeIsValid(): Promise<boolean> {
    const tipoHoras = this.taskForm.get('sCodigo_Tipo_Horas')?.value;
    if (!tipoHoras || tipoHoras === '1') {
      return true;
    }
    await this.validateOutOfScheduleRange();
    this.setTaskMessages();
    return !!this.taskForm.get('dHora_Inicio')?.value && this.taskForm.valid;
  }

  async validateOutOfScheduleRange(request = ++this.scheduleRangeRequest): Promise<void> {
    const control = this.taskForm.get('dHora_Inicio');
    const dDate = this.currentValidations?.dDate;
    const dHoraInicio = control?.value;
    const dHoraFin = this.taskForm.get('dHora_Fin')?.value;
    const isRegularHours = this.taskForm.get('sCodigo_Tipo_Horas')?.value === '1';
    const stillCurrent = () => request === this.scheduleRangeRequest;
    if (!control || !stillCurrent()) return;
    if (isRegularHours || !dDate) {
      control.setErrors(null);
      return;
    }
    const { available, fullyBooked } = await this.getAvailableOutOfScheduleRanges(dDate);
    if (!stillCurrent()) return;
    const message = formatOutOfScheduleRangesMessage(available, fullyBooked, dDate);
    if (!this.isCompleteHour(dHoraInicio) || !this.isCompleteHour(dHoraFin)) {
      control.setErrors({ fueraDeRangoMarcacion: message });
      control.markAsTouched();
      return;
    }
    const dFecha = moment(dDate).format('YYYY-MM-DD');
    const placed = this.placeRangeInsideAvailable(dFecha, dHoraInicio, dHoraFin, available);
    const formDay = moment(dFecha, 'YYYY-MM-DD');
    const startsNextDawn = placed?.start.clone().startOf('day').isAfter(formDay, 'day')
      || this.startsOnlyOnNextDawn(dFecha, dHoraInicio, available);
    if (startsNextDawn) {
      control.setErrors({
        fueraDeRangoMarcacion: `No existen marcas en la fecha ${formDay.format('DD/MM/YYYY')} para validar tu solicitud.`,
      });
      control.markAsTouched();
      this.taskForm.patchValue({ dFecha_Inicio: null, dFecha_Fin: null }, { emitEvent: false });
      return;
    }
    if (placed) {
      this.taskForm.patchValue({
        dFecha_Inicio: placed.start,
        dFecha_Fin: `${placed.end.format('YYYY-MM-DD')} ${placed.end.format('HH:mm')}`,
      }, { emitEvent: false });
    }
    control.setErrors(placed ? null : { fueraDeRangoMarcacion: message });
  }

  private startsOnlyOnNextDawn(
    dFecha: string,
    dHoraInicio: string,
    available: OutOfScheduleRange[]
  ): boolean {
    const start = moment(`${dFecha} ${dHoraInicio}`, ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm'], true);
    if (!start.isValid()) return false;
    const onFormDay = available.some(range => start.isSameOrAfter(range.start) && start.isBefore(range.end));
    if (onFormDay) return false;
    const nextStart = start.clone().add(1, 'day');
    return available.some(range =>
      range.start.isSame(start, 'day')
      && range.end.isAfter(start, 'day')
      && nextStart.isSameOrAfter(range.start)
      && nextStart.isBefore(range.end)
    );
  }

  private isCompleteHour(value: string | null | undefined): boolean {
    return !!value && moment(value, ['HH:mm:ss', 'HH:mm'], true).isValid();
  }

  private toHHmm(value: string | null | undefined): string {
    const parsed = moment(value, ['HH:mm:ss', 'HH:mm'], true);
    return parsed.isValid() ? parsed.format('HH:mm') : (value ?? '');
  }

  private placeRangeInsideAvailable(
    dFecha: string,
    dHoraInicio: string,
    dHoraFin: string,
    available: OutOfScheduleRange[]
  ): OutOfScheduleRange | null {
    const hourFormats = ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm'];
    const rangeStart = moment(`${dFecha} ${dHoraInicio}`, hourFormats, true);
    let rangeEnd = moment(`${dFecha} ${dHoraFin}`, hourFormats, true);
    if (!rangeStart.isValid() || !rangeEnd.isValid()) return null;
    if (rangeEnd.isBefore(rangeStart)) {
      rangeEnd = rangeEnd.add(1, 'day');
    }
    if (isInsideOutOfScheduleRanges(available, rangeStart, rangeEnd)) {
      return { start: rangeStart, end: rangeEnd };
    }
    const nextStart = rangeStart.clone().add(1, 'day');
    const nextEnd = rangeEnd.clone().add(1, 'day');
    if (isInsideOutOfScheduleRanges(available, nextStart, nextEnd)) {
      return { start: nextStart, end: nextEnd };
    }
    return null;
  }

  private occupiedRangesCache: { dDate: string; excludeId: number | null; ranges: OutOfScheduleRange[] } | null = null;

  private async getAvailableOutOfScheduleRanges(dDate: string): Promise<{
    available: OutOfScheduleRange[];
    fullyBooked: boolean;
    droppedDawnMinutes: number;
  }> {
    const { aIntervals, scheduleIntervals } = await this.getIntervalsAndScheduleForDate(dDate);
    const baseRanges = getOutOfScheduleRanges(aIntervals, scheduleIntervals);
    const occupied = [
      ...this.getLocalOccupiedRanges(dDate),
      ...await this.getSavedOccupiedRanges(dDate),
    ];
    const date = moment(dDate).format('YYYY-MM-DD');
    const remaining = subtractOccupiedRanges(baseRanges, occupied);
    const { kept, droppedMinutes } = withoutNextDawnSlices(remaining, date);
    return {
      available: kept,
      fullyBooked: baseRanges.length > 0 && kept.length === 0,
      droppedDawnMinutes: droppedMinutes,
    };
  }

  private getLocalOccupiedRanges(dDate: string): OutOfScheduleRange[] {
    const date = moment(dDate).format('YYYY-MM-DD');
    return this.bdArray.flatMap((task) => {
      if (task.editState || String(task.sCodigo_Tipo_Horas) === '1') return [];
      if (!task.dHora_Inicio || !task.dHora_Fin) return [];
      if (moment(task.dFecha_Registro).format('YYYY-MM-DD') !== date) return [];
      const range = this.toOccupiedRange(
        date,
        task.dHora_Inicio,
        task.dHora_Fin,
        task.dFecha_Fin,
        task.dFecha_Inicio
      );
      return range ? [range] : [];
    });
  }

  private async getSavedOccupiedRanges(dDate: string): Promise<OutOfScheduleRange[]> {
    const date = moment(dDate).format('YYYY-MM-DD');
    const excludeId = this.isEditRawTask ? this.currentId : null;
    if (this.occupiedRangesCache?.dDate === date && this.occupiedRangesCache.excludeId === excludeId) {
      return this.occupiedRangesCache.ranges;
    }
    const nId_Colab = this.data.oTask
      ? this.data.oTask.nId_Colaborador
      : Number.parseInt(localDB.getItem('idColaborador'));
    try {
      const resp = await firstValueFrom(
        this._taskService.getOccupiedNonRegularRanges(nId_Colab, date, excludeId)
      );
      const ranges = (resp?.data ?? []).flatMap((item) => {
        const start = moment(item.dInicio);
        const end = moment(item.dFin);
        if (!start.isValid() || !end.isValid() || !end.isAfter(start)) return [];
        return [{ start, end }];
      });
      this.occupiedRangesCache = { dDate: date, excludeId, ranges };
      return ranges;
    } catch {
      return [];
    }
  }

  private toOccupiedRange(
    dDate: string,
    horaInicio: string,
    horaFin: string,
    fechaFin?: string | moment.Moment | null,
    fechaInicio?: string | moment.Moment | null
  ): OutOfScheduleRange | null {
    const start = this.combineDateAndTime(fechaInicio, dDate, horaInicio);
    let end = this.combineDateAndTime(fechaFin, dDate, horaFin);
    if (end.isSameOrBefore(start)) {
      end = this.combineDateAndTime(null, dDate, horaFin).add(1, 'day');
    }
    if (!start.isValid() || !end.isValid() || !end.isAfter(start)) return null;
    return { start, end };
  }

  private combineDateAndTime(
    fecha: string | moment.Moment | null | undefined,
    fallbackDate: string,
    hora: string
  ): moment.Moment {
    const formats = ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm', 'YYYY-MM-DD H:mm'];
    if (fecha) {
      const parsed = moment(fecha, formats);
      const text = moment.isMoment(fecha) ? fecha.format('YYYY-MM-DD HH:mm:ss') : String(fecha);
      if (parsed.isValid() && /\d{1,2}:\d{2}/.test(text)) {
        return parsed;
      }
      if (parsed.isValid()) {
        return moment(`${parsed.format('YYYY-MM-DD')} ${hora}`, formats);
      }
    }
    return moment(`${fallbackDate} ${hora}`, formats);
  }

  getEndHourInToday(
    marcas: MarkDetail[],
    horarios: CollaboratorMarksResponse[]
  ): string {
    let hour = '00:00:00';

    if (horarios.length) {
      const start = marcas[0].dDate;
      const tolerance = horarios[0].nTolerancia;
      const startSchedule = horarios[0].dtime;
      const endSchedule = horarios.at(-1)!.dtime;
      hour = moment(endSchedule).format('HH:mm:ss');
      if (moment(start).isBefore(moment(startSchedule))) {
        const diff = moment(startSchedule).diff(start, 'minutes');
        hour =
          diff <= tolerance
            ? moment(endSchedule).add(diff, 'minutes').format('HH:mm:ss')
            : hour;
      }
    }
    return hour;
  }

  async initCurrentMaxMinMinutes() {
    if (moment(this.currentValidations?.dDate).isSame(this.today, 'days')) {
      this.setScheduleIntervals();
      const aIntervals = marksOfJornada(
        this.intervalsObj,
        this.currentValidations?.dDate ?? ''
      );
      if (aIntervals.length > 0) {
        let { dentro, fuera, endHour } = getMinutesInSchedule(
          aIntervals,
          this.scheduleIntervals
        );
        this.maxCurrentMinutesRegular = dentro;
        this.maxCurrentMinutesNoRegular = fuera;
        let index = this.listValidations.findIndex(
          (v) => v.dDate === this.currentValidations?.dDate
        );
        let indexBase = this.listValidationsBase.findIndex(
          (v) => v.dDate === this.currentValidations?.dDate
        );

        if (this.currentValidations) {
          this.currentValidations.nRequired = dentro;
          this.currentValidations.nRequiredNoRegular = fuera;
          this.currentValidations.salida = endHour;
        }
        if (index >= 0) {
          this.listValidations[index].nRequired = this.maxCurrentMinutesRegular;
          this.listValidations[index].nRequiredNoRegular =
            this.maxCurrentMinutesNoRegular;
          this.listValidations[index].salida = endHour;
          if (this.spinnerLoad) {
            this.listValidationsBase[indexBase].nRequired = structuredClone(
              this.maxCurrentMinutesRegular
            );
            this.listValidationsBase[indexBase].nRequiredNoRegular =
              structuredClone(this.maxCurrentMinutesNoRegular);
            this.listValidationsBase[indexBase].salida =
              structuredClone(endHour);
          }
        }
      }
    } else {
      this.maxCurrentMinutesRegular = Math.max(
        this.currentValidations?.nRequired ?? 0,
        0
      );
      this.maxCurrentMinutesNoRegular = Math.max(
        this.currentValidations?.nRequiredNoRegular ?? 0,
        0
      );
    }
    const minsRecuperar = Math.max(this.nMinsRecuperar ?? 0, 0);
    this.maxCurrentMinutesRegular = Math.max(
      this.maxCurrentMinutesRegular - (this.currentValidations?.nReady ?? 0),
      0
    );
    this.maxCurrentMinutesNoRegular = Math.max(
      this.maxCurrentMinutesNoRegular -
      (this.currentValidations?.nReadyNoRegular ?? 0),
      0
    );
    this.maxMinRecuperar =
      Math.min(minsRecuperar, this.maxCurrentMinutesNoRegular);
    if (
      this.currentValidations?.nReadyMark === 0 &&
      this.currentValidations?.nRecomended_Marks > 0
    ) {
      this.maxCurrentMinutesRegular = 0;
      this.maxCurrentMinutesNoRegular = 0;
      this.maxMinRecuperar = 0;
    }
    this.setMaxMinutesByTipoHoras();
    this.cdr.detectChanges();
    void this.excludeNextDawnMinutes();
  }

  setnReadyValue(targetDate?: string) {
    const currentDate = targetDate ?? this.currentValidations?.dDate;
    if (!currentDate) return;

    let indexVal = this.listValidations.findIndex((v) =>
      moment(v.dDate).isSame(moment(currentDate), 'days')
    );
    let indexBase = this.listValidationsBase.findIndex((v) =>
      moment(v.dDate).isSame(moment(currentDate), 'days')
    );
    if (indexVal < 0 || indexBase < 0) return;

    let localRegularValue = 0;
    let baseRegularValue = this.listValidationsBase[indexBase].nReady;
    let localNoRegularValue = 0;
    let baseNoRegularValue =
      this.listValidationsBase[indexBase].nReadyNoRegular;

    for (const x of this.bdArray) {
      const countedDate =
        x.sCodigo_Tipo_Horas == '1'
          ? x.dFecha_Registro
          : x.dFecha_Jornada || x.dFecha_Registro;
      if (!moment(countedDate).isSame(moment(currentDate), 'days')) {
        continue;
      }

      if (!x.editState) {
        if (x.sCodigo_Tipo_Horas == '1') {
          localRegularValue += x.nMinutos;
        } else {
          localNoRegularValue += x.nMinutos;
        }
      }
    }
    let newRegularValue = localRegularValue + baseRegularValue;
    let newNoRegularValue = localNoRegularValue + baseNoRegularValue;
    this.listValidations[indexVal].nReady = newRegularValue;
    this.listValidations[indexVal].nReadyNoRegular = newNoRegularValue;

    if (
      this.currentValidations &&
      moment(this.currentValidations.dDate).isSame(moment(currentDate), 'days')
    ) {
      this.currentValidations.nReady = newRegularValue;
      this.currentValidations.nReadyNoRegular = newNoRegularValue;
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  handleBeforeUnload(event: BeforeUnloadEvent): void {
    if (this.bdArray.length > 0) {
      event.preventDefault();
      event.returnValue = '';
    }
  }

  cancel() {
    if (this.isEditRawTask && this.mode === 'update') {
      this.dialogRef.close(false);
      return;
    }
    if (this.bdArray.length > 0) {
      this._smartAlert
        .init({
          type: 'quest',
          title: '¿Salir sin Guardar?',
          showCancelButton: true,
        })
        .subscribe((result: SmartAlertResult) => {
          if (!result.confirmStatus && !result.denyStatus) {
            return;
          } else {
            this.dialogRef.close(false);
            this.onAdd.emit(false);
          }
        });
    } else {
      this.dialogRef.close(false);
    }
  }

  setMaxMinDate() {
    this.listValidations.sort((a, b) => moment(b.dDate).diff(moment(a.dDate)));
    this.minDate = moment(this.listValidations.at(-1)?.dDate).toDate();
    this.maxDate = this.today.toDate();
  }

  async addTask() {
    this.taskForm.markAllAsTouched();
    if (!(await this.ensureNonRegularRangeIsValid())) {
      this.loading = false;
      return;
    }
    if (this.taskForm.valid) {
      let oldValidation = structuredClone(this.nMinsRecuperar);
      let task = this.taskForm.getRawValue();
      const tipo = this.TIPOS_HORA_ARRAY.find(
        (x) => x.sCodigo == task.sCodigo_Tipo_Horas
      );
      task.sNombre_Tipo_Horas = tipo?.sDescripcion || '';
      if (task.sCodigo_Tipo_Horas !== '1') {
        const dFecha_Jornada = await this.getJornadaDate(task.dFecha_Registro, task.dFecha_Inicio, task.dFecha_Fin);
        if (dFecha_Jornada) task.dFecha_Jornada = dFecha_Jornada;
      }
      task.id = this.fakeId;
      task.editState = false;
      this.fakeId++;
      this.bdArray.push(task);
      this.taskForm.get('sDetalle')?.reset();
      this.taskForm.patchValue({
        dHora_Inicio: null,
        dHora_Fin: null,
        dFecha_Inicio: null,
        dFecha_Fin: null,
      }, { emitEvent: false });
      this.setLocalMins();
      await this.validateOutOfScheduleRange();
      this.setTaskMessages();
      if (this.nMinsRecuperar != oldValidation) {
        this.temp_tipo_hora = this.taskForm.get('sCodigo_Tipo_Horas')?.value;
        this.setTipoHoras();
      }
    } else {
      this.loading = false;
    }
  }

  private async getJornadaDate(
    dFecha_Registro: moment.MomentInput,
    dFecha_Inicio: moment.MomentInput,
    dFecha_Fin: moment.MomentInput
  ): Promise<string | null> {
    const jornada = moment(dFecha_Registro);
    const inicio = dFecha_Inicio ? moment(dFecha_Inicio) : null;
    const fin = dFecha_Fin ? moment(dFecha_Fin) : null;
    let belongsToJornada = !inicio?.isValid() || inicio.isSame(jornada, 'day');
    if (!belongsToJornada && inicio?.isValid() && fin?.isValid()) {
      const { aIntervals } = await this.getIntervalsAndScheduleForDate(
        jornada.format('YYYY-MM-DD')
      );
      belongsToJornada = aIntervals.some((entry) => {
        if (entry.nType_Mark !== 1 || !moment(entry.dDate).isSame(jornada, 'day')) {
          return false;
        }
        const exit = aIntervals.find(
          (mark) => mark.nType_Mark === 2 && mark.nInterval === entry.nInterval
        );
        if (!exit) return false;
        return inicio.isBefore(moment(exit.dDate)) && fin.isAfter(moment(entry.dDate));
      });
    }
    return belongsToJornada ? jornada.format('YYYY-MM-DD') : null;
  }

  setValidationsTaskStatus() {
    this.listValidations.forEach((value, i, arr) => {
      if (value.nReady === value.nRequired) {
        arr[i].sEstado = 'COMPLETO';
      }

      if (
        value.nReady > 0 &&
        value.nRequired > 0 &&
        value.nReady < value.nRequired
      ) {
        arr[i].sEstado = 'INCOMPLETO';
      }

      if (value.nReady === 0 && value.nRequired > 0) {
        arr[i].sEstado = 'FALTA';
      }
    });

    let oTareoByStatus_base = groupBy(this.listValidations, (i) => i.sEstado);
    let oTareoByStatus: { [key: string]: string[] } = {};

    for (const key in oTareoByStatus_base) {
      oTareoByStatus[key] = oTareoByStatus_base[key].map(
        (value: any) => value.dDate
      );
    }

    this.oTareoByStatus['FALTA'] = oTareoByStatus['FALTA'] ?? [];

    this.oTareoByStatus['COMPLETO'] = oTareoByStatus['COMPLETO'] ?? [];

    this.oTareoByStatus['INCOMPLETO'] = oTareoByStatus['INCOMPLETO'] ?? [];
  }

  setMaxMinutesByTipoHoras() {
    const tipoHorasValue = this.taskForm.get('sCodigo_Tipo_Horas')?.value;
    if (!tipoHorasValue) {
      this.maxCurrentMinutes = 0;
      this.cdr.detectChanges();
      return;
    }
    if (tipoHorasValue === '1') {
      this.maxCurrentMinutes = this.maxCurrentMinutesRegular;
    } else if (tipoHorasValue === String(TIME_TYPE.RECUPERACIÓN)) {
      this.maxCurrentMinutes = this.maxMinRecuperar;
    } else {
      this.maxCurrentMinutes = this.maxCurrentMinutesNoRegular;
    }
    this.cdr.detectChanges();
  }

  setLocalMins(oTask?: any) {
    const targetDate = oTask?.dFecha_Registro
      ? moment(oTask.dFecha_Registro).format('YYYY-MM-DD')
      : this.currentValidations?.dDate;
    this.setnReadyValue(targetDate);
    if (
      targetDate &&
      this.currentValidations &&
      !moment(this.currentValidations.dDate).isSame(moment(targetDate), 'days')
    ) {
      this.setnReadyValue(this.currentValidations.dDate);
    }
    const targetValidation = targetDate
      ? this.listValidations.find((v) => v.dDate === targetDate)
      : this.currentValidations;
    if (!targetValidation) {
      return;
    }
    let maxRegularMins = targetValidation.nRequired ?? 0;
    let maxNoRegularMins = targetValidation.nRequiredNoRegular ?? 0;
    let regularMins = targetValidation.nReady ?? 0;
    let noRegularMins = targetValidation.nReadyNoRegular ?? 0;
    this.maxCurrentMinutesRegular = Math.max(maxRegularMins - regularMins, 0);
    this.maxCurrentMinutesNoRegular = Math.max(
      maxNoRegularMins - noRegularMins,
      0
    );
    if (!!oTask && this.isEditRawTask && this.currentValidations) {
      this.adjustLocalMinsForEditingTask(oTask);
    }
    this.setMaxMinutesByTipoHoras();
    this.setMisRecuperar();
    this.setValidationsTaskStatus();
    void this.excludeNextDawnMinutes();
  }

  private async excludeNextDawnMinutes(): Promise<void> {
    const request = ++this.dawnMinutesRequest;
    const dDate = this.currentValidations?.dDate;
    if (!dDate || !this.currentValidations) return;
    if (
      this.currentValidations.nReadyMark === 0 &&
      this.currentValidations.nRecomended_Marks > 0
    ) {
      return;
    }
    const required = this.currentValidations.nRequiredNoRegular ?? 0;
    const ready = this.currentValidations.nReadyNoRegular ?? 0;
    const { droppedDawnMinutes } = await this.getAvailableOutOfScheduleRanges(dDate);
    if (request !== this.dawnMinutesRequest) return;
    if (!moment(this.currentValidations.dDate).isSame(dDate, 'day')) return;
    this.maxCurrentMinutesNoRegular = Math.max(required - ready - droppedDawnMinutes, 0);
    this.maxMinRecuperar = Math.min(this.nMinsRecuperar ?? 0, this.maxCurrentMinutesNoRegular);
    this.setMaxMinutesByTipoHoras();
    this.cdr.detectChanges();
  }

  private adjustLocalMinsForEditingTask(oTask: any) {
    const taskDate = moment(
      oTask.sCodigo_Tipo_Horas === '1'
        ? oTask.dFecha_Registro
        : oTask.dFecha_Jornada || oTask.dFecha_Registro
    ).format('YYYY-MM-DD');
    const currentDate = this.currentValidations!.dDate;
    if (taskDate !== currentDate) {
      return;
    }
    if (oTask.sCodigo_Tipo_Horas === '1') {
      this.maxCurrentMinutesRegular += oTask.nMinutos ?? 0;
      this.currentValidations!.nReady = Math.max(
        this.currentValidations!.nReady - (oTask.nMinutos ?? 0),
        0
      );
    } else {
      this.maxCurrentMinutesNoRegular += oTask.nMinutos ?? 0;
      this.currentValidations!.nReadyNoRegular = Math.max(
        this.currentValidations!.nReadyNoRegular - (oTask.nMinutos ?? 0),
        0
      );
    }
    let index = this.listValidations.findIndex(
      (v) => v.dDate === this.currentValidations?.dDate
    );
    if (index >= 0) {
      this.listValidations[index].nReady = this.currentValidations!.nReady;
      this.listValidations[index].nReadyNoRegular =
        this.currentValidations!.nReadyNoRegular;
    }
  }

  taskActions(action: { sAction: string; oTask: TempTaskModal }) {
    switch (action.sAction) {
      case 'edit':
        this.enableEditLocalTask(action.oTask);
        break;
      case 'delete':
        this.deleteLocalTask(action.oTask.id!);
        this.setMisRecuperar();
        this.setTipoHoras();
        void this.refreshRangesAfterLocalChange();
        break;
    }
  }

  enableEditLocalTask(oTask: TempTaskModal) {
    this.tempForm = this.taskForm.getRawValue();
    this.mode = 'update';
    let index = this.bdArray.findIndex((x) => x.id === oTask.id);
    if (index >= 0) {
      this.currentId = this.bdArray[index].id!;
    }
    for (const item of this.bdArray) {
      item.editState = false;
    }
    if (index >= 0) {
      this.bdArray[index].editState = true;
    }
    const taskDate = moment(oTask.dFecha_Registro).format('YYYY-MM-DD');
    this.setCurrentValidations(taskDate);
    this.setLocalMins(oTask);
    this.temp_tipo_hora = oTask.sCodigo_Tipo_Horas;
    this.initCurrentMaxMinMinutes();
    this.setTipoHoras();
    this.initTaskByLocalData(oTask);
    this.initStatus.rq = false;
    this.initStatus.cat = false;
    if (oTask.sCodigo_Proyecto) {
      setTimeout(() => {
        this.taskForm.patchValue({
          sCodigo_Proyecto: oTask.sCodigo_Proyecto,
          sNombre_Proyecto: oTask.sNombre_Proyecto,
          sCodigo_Requerimiento: oTask.sCodigo_Requerimiento,
          sNombre_Requerimiento: oTask.sNombre_Requerimiento,
          sCodigo_Categoria: oTask.sCodigo_Categoria,
          sNombre_Categoria: oTask.sNombre_Categoria,
        });
      }, 500);
    }
    this.setValidationsTaskStatus();
    this.setTaskMessages();
  }

  async editLocalTask(id: number) {
    this.taskForm.markAllAsTouched();
    if (!(await this.ensureNonRegularRangeIsValid())) {
      return;
    }
    if (this.taskForm.valid) {
      let index = this.bdArray.findIndex((x) => x.id === id);
      if (index >= 0) {
        const id = this.fakeId;
        this.bdArray[index].editState = false;
        let tempTask = this.taskForm.getRawValue();
        this.bdArray[index] = { ...tempTask, id };
        this.bdArray[index].sMensaje_Error = '';
        this.setLocalMins();
        if (this.tempForm) {
          this.temp_tipo_hora = this.tempForm.sCodigo_Tipo_Horas;
          this.setTipoHoras();
          this.initTaskByLocalData(this.tempForm);
          this.tempForm = null;
        }
        this.mode = 'create';
        this.currentId = 0;
        this.fakeId++;
        this.setLocalMins();
      }
    }
  }

  resetChanges() {
    if (this.currentId) {
      let index = this.bdArray.findIndex((x) => x.id === this.currentId);
      if (index >= 0) {
        const taskToReset = this.bdArray[index];
        this.bdArray[index].editState = false;
        this.bdArray[index].id = this.fakeId;
        this.bdArray[index].sMensaje_Error = '';
        
        this.setLocalMins(taskToReset);
        this.setValidationsTaskStatus();
        
        if (this.tempForm) {
          this.temp_tipo_hora = this.tempForm.sCodigo_Tipo_Horas;
          this.setTipoHoras();
          this.initTaskByLocalData(this.tempForm);
          this.tempForm = null;
        }
        
        this.mode = 'create';
        this.currentId = 0;
        this.fakeId++;
        this.setTaskMessages();
      }
    }
  }

  async editRowTask() {
    this.loading = true;
    this.taskForm.markAllAsTouched();
    if (!(await this.ensureNonRegularRangeIsValid())) {
      this.loading = false;
      return;
    }
    let today = this.today.format('YYYY-MM-DD');
    if (this.taskForm.valid) {
      let newtask = this.taskForm.getRawValue();
      newtask.dFecha_Registro = moment(newtask.dFecha_Registro).format(
        'YYYY-MM-DD'
      );
      newtask.nId = Number(this.currentId);
      newtask.sLastWorkDay = today;
      newtask.nId_Colaborador = this.currentColId;
      if (Number(newtask.sCodigo_Tipo_Horas) === TIME_TYPE.HORARIO_REGULAR) {
        delete newtask.dFecha_Fin;
        delete newtask.dHora_Fin;
        delete newtask.dHora_Inicio;
        delete newtask.dFecha_Inicio;
      } else {
        newtask.dFecha_Fin = moment(newtask.dFecha_Fin).format('YYYY-MM-DD');
        newtask.dFecha_Inicio = moment(newtask.dFecha_Inicio).format(
          'YYYY-MM-DD'
        );
      }

      this._taskService.editTask(this.currentId, newtask).subscribe({
        next: (resp) => {
          if (resp.isSuccess) {
            this._taskRefreshService.triggerRefresh();
            this._smartAlert.init({
              type: 'success',
              timer: 1.5,
              timerProgressBar: true,
            });
            this.dialogRef.close(true);
          } else {
            this.editError = (resp.data.sMensaje_Error ?? '').replace(/\n/g, '<br>');
            this.loading = false;
          }
        },
        error: (err) => {
          this.editError = 'Hubo un error, por favor intenta más tarde';
          this.loading = false;
        },
      });
    } else {
      this.loading = false;
    }
  }

  private async refreshRangesAfterLocalChange(): Promise<void> {
    await this.validateOutOfScheduleRange();
    this.setTaskMessages();
  }

  deleteLocalTask(id: number) {
    const currentTipoHora = this.taskForm.get('sCodigo_Tipo_Horas')?.value;
    if (currentTipoHora) {
      this.temp_tipo_hora = currentTipoHora;
    }
    const taskToDelete = this.bdArray.find(x => x.id === id);
    this.bdArray = this.bdArray.filter((x) => x.id != id);
    if (taskToDelete) {
      this.setLocalMins(taskToDelete);
      this.setValidationsTaskStatus();
      this.setTipoHoras();
      this.setTaskMessages();
    }
  }

  initTaskByLocalData(tempTask: TempTaskModal) {
    const fechaRegistro =
      this.mode === 'create' ? this.today : tempTask.dFecha_Registro;
    this.taskForm.patchValue({
      dFecha_Registro: fechaRegistro,
      nMinutos: tempTask.nMinutos || 60,
      nCantidad: (tempTask.nMinutos || 60) / 60 || null,
      sCodigo_Tipo_Actividad: tempTask.sCodigo_Tipo_Actividad || null,
      sCodigo_Proyecto: tempTask.sCodigo_Proyecto || null,
      sCodigo_Requerimiento: tempTask.sCodigo_Requerimiento || null,
      sCodigo_Categoria: tempTask.sCodigo_Categoria || null,
      sCodigo_Tipo_Horas:
        tempTask.sCodigo_Tipo_Horas || this.temp_tipo_hora || null,

      sNombre_Tipo_Actividad: tempTask.sNombre_Tipo_Actividad || null,
      sNombre_Proyecto: tempTask.sNombre_Proyecto || null,
      sNombre_Requerimiento: tempTask.sNombre_Requerimiento || null,
      sNombre_Categoria: tempTask.sNombre_Categoria || null,
      sNombre_Tipo_Horas: tempTask.sNombre_Tipo_Horas || null,

      sDetalle: tempTask.sDetalle || null,
      sAnotaciones: tempTask.sAnotaciones || null,
      dHora_Inicio: tempTask.dHora_Inicio || null,
      dHora_Fin: tempTask.dHora_Fin || null,
      dFecha_Inicio:
        this.mode === 'create' ? this.today : tempTask.dFecha_Registro || null,
      dFecha_Fin: tempTask.dFecha_Fin || null,
    });
    if (this.mode === 'update') {
      this.initStatus.rq = false;
      this.initStatus.cat = false;
    }
  }

  confirmSave() {
    this._smartAlert
      .init({
        type: 'quest',
        title: '¿Que acción desea realizar?',
        showCancelButton: true,
        showDenyButton: true,
        confirmButtonText: 'Guardar y continuar',
        denyButtonText: 'Guardar y salir',
        cancelButtonText: 'Cancelar',
      })
      .subscribe((result: SmartAlertResult) => {
        if (!result.confirmStatus && !result.denyStatus) return;
        this.save(result);
        this._smartAlert.close();
      });
  }

  save(option: SmartAlertResult) {
    this.loading = true;
    if (this.bdArray.length > 0) {
      let today = this.today.format('YYYY-MM-DD');
      let newbdArray = this.bdArray.map((x) => {
        x.dFecha_Registro = moment(x.dFecha_Registro).format('YYYY-MM-DD');
        x.id = this.mode === 'create' ? 0 : x.id;
        x.sLastWorkDay = today;
        if (Number(x.sCodigo_Tipo_Horas) === TIME_TYPE.HORARIO_REGULAR) {
          delete x.dFecha_Fin;
          delete x.dHora_Fin;
          delete x.dHora_Inicio;
          delete x.dFecha_Inicio;
        } else {
          x.dFecha_Fin = moment(x.dFecha_Fin).format('YYYY-MM-DD');
          x.dFecha_Inicio = moment(x.dFecha_Inicio).format('YYYY-MM-DD');
        }
        return x;
      });

      this._taskService.addTask(newbdArray).subscribe((resp) => {
        this.loading = false;
        const initarr = this.bdArray.length;
        if (resp.isSuccess) {
          this._taskRefreshService.triggerRefresh();
          this._smartAlert.init({
            type: 'success',
            timer: 1.5,
            timerProgressBar: true,
          });
          if (option.denyStatus) {
            this.dialogRef.close(true);
          } else {
            this.bdArray = [];
            this.occupiedRangesCache = null;
            this.spinnerLoad = true;
            this.initTaskStatus();
          }
        } else {
          this.setDataError(resp);
          if (this.bdArray.length < initarr) {
            this.spinnerLoad = true;
            this.initTaskStatus();
          }
        }
      });
    }
  }

  setDataError(resp: GenericResponse<any>) {
    const { bdArray } = mapErrorsToTaskArrays<TempTaskModal>(resp);
    this.currentId = 0;
    this.bdArray = bdArray.map((x) => {
      x.id = this.fakeId;
      this.fakeId++;
      return x;
    });

    this.taskForm.get('sDetalle')!.reset();
  }
}
